import { render, staticRenderFns } from "./DeleteClientModal.vue?vue&type=template&id=b563b110"
import script from "./DeleteClientModal.vue?vue&type=script&lang=js"
export * from "./DeleteClientModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteClientModal.vue?vue&type=style&index=0&id=b563b110&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports